import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useEmailAddresses = () => {
  const query = useQuery({
    queryKey: [QueryKeys.EMAIL_ADDRESSES],
    queryFn: () => accountRepo.getEmailAddresses(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseEmailAddresses = ReturnType<typeof useEmailAddresses>;
